<template>
  <OutgoingReturnForm formTitle="Buat Retur Obral" defaultDescription="Obral" />
</template>

<script>
import OutgoingReturnForm from './OutgoingReturnForm.vue'
export default {
  components: { OutgoingReturnForm }
}
</script>
